import ShModel from 'sh-www/models/sh-model';
import { hasMany, belongsTo, attr } from '@ember-data/model';

class BrandModel extends ShModel {
  @attr('string') name;
  @attr('boolean') default;
  @attr('boolean') isThirdParty;
  @attr('string') fullName;

  @belongsTo('company', { async: false}) company;
  @hasMany('companyTeam', { async: false }) companyTeams;
  @belongsTo ('image', { async: false }) image;

  @hasMany('projectdigest', { async: false }) projectdigest;
  @hasMany('domain', { async: false }) domains;

  get displayedName() {
    return this.fullName ?? this.name;
  }
}

export default BrandModel;
